/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ target: NonNullable<unknown> }} Spaces_Move_Files_SubtitleInputs */



/**
* | output |
* | --- |
* | "Files will be moved to {target}" |
*
* @param {Spaces_Move_Files_SubtitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_move_files_subtitle = /** @type {((inputs: Spaces_Move_Files_SubtitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Move_Files_SubtitleInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Dateien werden nach ${i?.target} verschoben`)
	return /** @type {LocalizedString} */ (`Files will be moved to ${i?.target}`)
});